import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import api from 'utils/api';
import cancelFileNotification from 'utils/file/cancelFileNotification';
import { playlistQueryKeys } from 'actions/playlists';
import { assetQueryKeys } from 'actions/assets';
import { FILE_STATUS_VALUES, fileQueryKeys } from 'actions/file';
function useFetchFileStatus(_ref) {
  var fileId = _ref.fileId,
    parentPlaylistId = _ref.parentPlaylistId,
    assetId = _ref.assetId,
    oldFileStatus = _ref.oldFileStatus,
    refetchInterval = _ref.refetchInterval,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? false : _ref$enabled,
    _ref$refetchIntervalI = _ref.refetchIntervalInBackground,
    refetchIntervalInBackground = _ref$refetchIntervalI === void 0 ? false : _ref$refetchIntervalI,
    _ref$cancelFileNotifi = _ref.cancelFileNotificationOnSuccess,
    cancelFileNotificationOnSuccess = _ref$cancelFileNotifi === void 0 ? false : _ref$cancelFileNotifi;
  var queryClient = useQueryClient();
  function fetchFile() {
    return _fetchFile.apply(this, arguments);
  }
  function _fetchFile() {
    _fetchFile = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$api, fileStatus;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (fileId) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return", null);
          case 1:
            _context.next = 2;
            return api('get', "/api/files/".concat(fileId), null);
          case 2:
            _yield$api = _context.sent;
            fileStatus = _yield$api.fileStatus;
            return _context.abrupt("return", fileStatus);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchFile.apply(this, arguments);
  }
  var _useQuery = useQuery({
      queryKey: fileQueryKeys.fileStatus(fileId),
      queryFn: fetchFile,
      staleTime: 5 * 60 * 1000,
      // If set to a number, all queries will continuously refetch at this frequency in milliseconds
      refetchInterval: enabled ? refetchInterval : false,
      // If set to true, queries that are set to continuously refetch with a refetchInterval will
      // continue to refetch while their tab/window is in the background
      refetchIntervalInBackground: refetchIntervalInBackground,
      // Disables the query from automatically running if set to false
      enabled: enabled
    }),
    fileStatus = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded);
  useEffect(function () {
    if (!fileStatus) {
      return;
    }
    if (oldFileStatus !== fileStatus) {
      if (assetId) {
        queryClient.invalidateQueries({
          queryKey: assetQueryKeys.singleAsset(assetId)
        });
      }
      if (parentPlaylistId) {
        queryClient.invalidateQueries({
          queryKey: playlistQueryKeys.singlePlaylistContent(parentPlaylistId)
        });
      }
    }
    if (
    // Cancels the file notification email if the successfully fetched status is either 'ready' or 'invalid'
    cancelFileNotificationOnSuccess && (fileStatus === FILE_STATUS_VALUES.READY || fileStatus === FILE_STATUS_VALUES.INVALID) && oldFileStatus !== fileStatus) {
      cancelFileNotification({
        fileId: fileId
      });
    }
  }, [assetId, cancelFileNotificationOnSuccess, fileId, fileStatus, oldFileStatus, parentPlaylistId, queryClient]);
  return _objectSpread({
    fileStatus: fileStatus
  }, result);
}
export default useFetchFileStatus;